import React from "react";

const ModalWindow = ({ children }) => {
  return <div className="modal-window">{children}</div>;
};

export default ModalWindow;

